import React from 'react';
import { Html, Line } from '@react-three/drei';

export const MeasurementScale = ({ width = 2, unit = "nm", color = "#425a70" }) => {
  const measureWidth = 1.5;

  return (
    <group position={[0, -2.5, 0]}>
      <Line
        points={[[-measureWidth, 0, 0], [measureWidth, 0, 0]]}
        color={color}
        lineWidth={1.5}
      />

      <Line points={[[-measureWidth, 0, 0], [-measureWidth, 0.2, 0]]} color={color} lineWidth={1.5} />
      <Line points={[[0, 0, 0], [0, 0.1, 0]]} color={color} lineWidth={1.5} />
      <Line points={[[measureWidth, 0, 0], [measureWidth, 0.2, 0]]} color={color} lineWidth={1.5} />

      <Html
        position={[-measureWidth, 0.5, 0]}
        center
        distanceFactor={10}
      >
        <div style={{
          fontSize: '12px',
          color: color,
          fontFamily: 'sans-serif',
          userSelect: 'none',
          paddingBottom: '2px'
        }}>
          0
        </div>
      </Html>

      <Html
        position={[measureWidth, 0.5, 0]}
        center
        distanceFactor={10}
      >
        <div style={{
          fontSize: '12px',
          color: color,
          fontFamily: 'sans-serif',
          userSelect: 'none',
          paddingBottom: '2px'
        }}>
          {width}{unit}
        </div>
      </Html>
    </group>
  );
};
